import { Grid } from "@material-ui/core";
import { InputTextMaster, MasterButton, Modal } from "App/Component/ui";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
} from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  today,
} from "App/utils/helpers";
import React, { useState } from "react";

function ModalTutupKunjungan({
  setShowModal,
  setRegistrationId,
  registrationId,
  setNewData,
  url = "/registration/registration/tutupregistrasi",
}) {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const [tanggal, setTanggal] = useState(today(true));
  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (registrationId === "") {
      defaultToastError("Pilih registrasi terlebih dahulu");
    }
    try {
      await instance2.post(
        url,
        {
          tanggal_selesai: tanggal,
        },
        {
          headers: {
            idregistration: registrationId,
          },
        }
      );
      defaultToastSuccess("Berhasil tutup kunjungan");
      setNewData();
      setRegistrationId("");
      setShowModal(false);
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError(error?.response?.data?.message);
    }
  };
  return (
    <Modal title={`Tutup Kunjungan`} show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid item sm={12}>
          <InputTextMaster
            label={"TANGGAL"}
            placeholder={"tanggal"}
            name='tanggal'
            value={tanggal}
            type='datetime-local'
            onChange={(e) => {
              setTanggal(e.target.value);
            }}
            id='tanggal'
          />
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
}

export default ModalTutupKunjungan;
